// Polyfills for browser compatibility
// This file MUST be imported first in main.tsx

// Ensure globalThis exists
if (typeof globalThis === 'undefined') {
  (function() {
    if (typeof self !== 'undefined') { 
      (self as any).globalThis = self; 
    } else if (typeof window !== 'undefined') { 
      (window as any).globalThis = window; 
    } else if (typeof global !== 'undefined') { 
      (global as any).globalThis = global; 
    }
  })();
}

// Ensure Request and Response exist on window and globalThis
if (typeof Request === 'undefined') {
  (window as any).Request = function Request() {};
  (globalThis as any).Request = (window as any).Request;
}

if (typeof Response === 'undefined') {
  (window as any).Response = function Response() {};
  (globalThis as any).Response = (window as any).Response;
}

// Ensure process global exists
if (typeof (globalThis as any).process === 'undefined') {
  (globalThis as any).process = {
    env: { NODE_ENV: 'production' },
    version: '',
    versions: {},
    platform: 'browser',
    nextTick: function(callback: Function) { setTimeout(callback, 0); },
    cwd: function() { return '/'; },
    chdir: function() {},
    umask: function() { return 0; },
    on: function() {},
    once: function() {},
    off: function() {},
    emit: function() { return false; },
    prependListener: function() {},
    prependOnceListener: function() {},
    listeners: function() { return []; },
    binding: function() {},
    exit: function() {},
    kill: function() {},
    pid: 1,
    ppid: 0,
    title: 'browser',
    arch: 'x64',
    argv: [],
    execArgv: [],
    execPath: '',
    abort: function() {},
    allowedNodeEnvironmentFlags: new Set(),
    assert: function() {},
    features: {},
    getgid: function() { return 1; },
    setgid: function() {},
    getuid: function() { return 1; },
    setuid: function() {},
    getgroups: function() { return []; },
    setgroups: function() {},
    initgroups: function() {},
    stdout: null,
    stderr: null,
    stdin: null,
    openStdin: function() { return null; },
    getegid: function() { return 1; },
    geteuid: function() { return 1; },
    hrtime: function() { return [0, 0]; },
    cpuUsage: function() { return { user: 0, system: 0 }; },
    dlopen: function() {},
    uptime: function() { return 0; },
    memoryUsage: function() { return { rss: 0, heapTotal: 0, heapUsed: 0, external: 0 }; },
    resourceUsage: function() { 
      return {
        userCPUTime: 0, systemCPUTime: 0, maxRSS: 0, sharedMemorySize: 0,
        unsharedDataSize: 0, unsharedStackSize: 0, minorPageFault: 0,
        majorPageFault: 0, swappedOut: 0, fsRead: 0, fsWrite: 0,
        ipcSent: 0, ipcReceived: 0, signalsCount: 0,
        voluntaryContextSwitches: 0, involuntaryContextSwitches: 0
      };
    }
  };
}

// Ensure global alias exists
if (typeof (window as any).global === 'undefined') {
  (window as any).global = globalThis;
}
